import { createContext, useContext } from 'react';

export const INITIAL_STATE = {
  modalIsOpen: false,
  setModalIsOpen: () => void 0,
  bannerIsOpen: false,
  setBannerIsOpen: () => void 0,
  sendLaterModalIsOpen: false,
  setSendLaterModalIsOpen: () => void 0
};

export const ResendAccessContext = createContext(INITIAL_STATE);

export const useResendAccessContext = () => useContext(ResendAccessContext);
